import { render, staticRenderFns } from "./storageLocationProducts.vue?vue&type=template&id=4917066f&scoped=true&"
import script from "./storageLocationProducts.vue?vue&type=script&lang=js&"
export * from "./storageLocationProducts.vue?vue&type=script&lang=js&"
import style0 from "./storageLocationProducts.vue?vue&type=style&index=0&id=4917066f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4917066f",
  null
  
)

export default component.exports